<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <!-- <Card :bordered="false" dis-hover class="ivu-bg">
          <Row type="flex" justify="center" align="middle" class="ivu-text-center">
            <Col :xl="6" :lg="6" :md="6" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>待发货</p>
            <p style="font-size: 24px">111个订单</p>
            </Col>
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日全部订单</p>
            <p style="font-size: 24px">111 个订单</p>
            </Col>
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日已完成订单</p>
            <p style="font-size: 24px">
              111个订单
            </p>
            </Col>
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日订单收益</p>
            <p style="font-size: 24px">
              111 元
            </p>
            </Col>
          </Row>
        </Card> -->
        <div class="card">
          <div class="card-head">授权列表</div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Row>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <RadioGroup v-model="status" type="button" button-style="solid">
                  <Radio :label="-1">全部</Radio>
                  <Radio :label="1">正常</Radio>
                  <Radio :label="0">封禁</Radio>
                </RadioGroup>
                </Col>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Input v-model="searchValue" placeholder="搜索">
                <Select v-model="searchType" slot="prepend" style="width: 110px">
                  <Option :value="1">手机号</Option>
                  <Option :value="2">域名</Option>
                </Select>
                <Button slot="append" icon="ios-search" @click="searchClick"></Button>
                </Input>
                </Col>
              </Row>


            </div>
            <Button v-if="this.$store.state.auth == 1" long type="dashed" icon="md-add" @click="addClick">添加</Button>

            <div v-if="data.length == 0">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>

              <div class="data-content">
                <div v-for="(item, index) in data" :key="index" class="list-item">

                  <div class="list-item-meta">
                    <div class="list-item-meta-avatar">
                      <span class="ivu-avatar ivu-avatar-square ivu-avatar-image ivu-avatar-large">
                        <img v-lazy="'http://' + item.url + '/favicon.ico'">
                      </span>
                    </div>
                    <div class="list-item-meta-content">
                      <div class="list-item-meta-title">
                        <a :href="'http://' + item.url" target="_blank" rel="noopener noreferrer">{{item.url}}</a>
                      </div>
                      <div class="list-item-meta-description">{{item.addtime}}</div>
                    </div>
                  </div>

                  <div class="list-content">
                    <div class="list-content-item">
                      <span>手机号</span>
                      <p>{{item.phone}}</p>
                    </div>
                    <div class="list-content-item">
                      <span>剩余天数</span>
                      <p>{{item.day}}</p>
                    </div>
                    <div class="list-content-item">
                      <span>所属项目</span>
                      <p>{{item.project_name}}</p>
                    </div>
                    <div class="list-content-item">
                      <span>当前版本</span>
                      <p>
                        <Tag type="border">{{item.version?item.version:'Null'}}</Tag>
                      </p>
                    </div>
                    <div class="list-content-item">
                      <span>授权状态</span>
                      <p v-if="item.status === 1">
                        <Icon type="md-checkmark-circle" color="#19be6b" size="22" />正常
                      </p>
                      <p v-if="item.status === 0" style="cursor: pointer;">
                        <Tooltip :content="item.err_msg?item.err_msg:null" placement="bottom">
                          <Icon type="md-close-circle" color="#ed4014" size="22" />封禁
                        </Tooltip>
                      </p>


                    </div>
                    <div class="list-content-item">
                      <span>可更换次数</span>
                      <p style="color:#19be6b">
                        {{item.replace}} 次
                      </p>
                    </div>
                   
                  </div>
                  <div class="list-menu-item">
                    <ButtonGroup size="small" shape="circle">
                      <Button type="primary" ghost @click="editClick(item)">编辑</Button>
                      <Button type="error" ghost @click="del(item.id)">删除</Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreate" :width="600" :styles="{top: '50px'}" :title="edit?'编辑授权':'添加授权'" :loading="creating"
      @on-ok="edit?editSave():addSave()">
      <Form ref="create" :model="createData" :rules="ruleValidate" :label-width="130">
        <FormItem label="手机号：" prop="phone">
          <Input v-model="createData.phone" :disabled="$store.state.auth == 1?false:true" placeholder="请输入手机号" />
        </FormItem>
        <FormItem label="所属项目：" prop="appid">
          <Select v-model="createData.appid" placeholder="请选择项目" v-if="$store.state.auth == 1">
            <Option v-for="item in projectList" :key="item.id" :value="item.appid">{{ item.name }}</Option>
          </Select>
          <Input v-model="createData.project_name" v-else :disabled="edit?true:false" placeholder="项目名称" />
        </FormItem>
        <FormItem label="所属授权商：" prop="user_id" v-if="$store.state.auth == 1">
          <Select v-model="createData.user_id" placeholder="请选择授权商">
            <Option v-for="item in UserList" :key="item.id" :value="item.id">{{ 'ID:'+item.id+'-('+ item.phone+')' }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="授权域名：" prop="url">
          <Input v-model="createData.url" placeholder="请输入授权域名" />
        </FormItem>
        <FormItem label="增减天数：" prop="day" v-if="$store.state.auth == 1">
          <InputNumber v-model="createData.day"></InputNumber>
        </FormItem>
        <FormItem label="可更换次数：" prop="replace" v-if="$store.state.auth == 1 && edit">
          <InputNumber v-model="createData.replace"></InputNumber>
        </FormItem>
        <FormItem label="授权状态：" prop="status">
          <i-switch v-model="createData.status" :true-value="1" :false-value="0" />
        </FormItem>
        <FormItem label="封禁原因：" v-show="edit && createData.status == 0">
          <Input v-model="createData.err_msg" placeholder="请输入封禁原因" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
  import {
    getAuth,
    getProject,
    getUserAll,
    delAuth,
    putAuth,
    postAuth
  } from "@/api";
  export default {
    data() {
      return {
        edit: false,
        pageIndex: 1,
        pageSize: 10,
        total: "",
        searchValue: "",
        searchType: 1,
        status: -1,

        ruleValidate: {
          appid: [{
            required: true,
            message: "请选择项目"
          }],
          user_id: [{
            required: true,
            message: "请选择授权商"
          }],
          day: [{
            required: true,
            message: "请填写授权天数",
          }],
          url: [{
            required: true,
            message: "请填写授权域名",
            trigger: "blur"
          }],
          phone: [{
            required: true,
            message: "请填写授权手机号",
            trigger: "blur"
          }],

        },
        createData: {},
        data: [],
        projectList: [],
        UserList: [],
        showCreate: false,
        creating: false,
      };
    },

    created() {

      this._getData();
      if (this.$store.state.auth == 1) {
        this._getUser()
        this._getProject()
      }

    },
    watch: {
      status(newVal, oldVal) {
        if (newVal != oldVal) {
          (this.pageIndex = 1), (this.pageSize = 10), this._getData();
        }
      },
      searchValue(newVal) {
        if (newVal == "") {
          (this.pageIndex = 1), (this.pageSize = 10), this._getData();
        }
      }
    },
    methods: {
      // 搜索库存
      searchClick() {
        (this.pageIndex = 1), (this.pageSize = 10), this._getData();
      },
      // 获取项目列表
      _getProject() {
        getProject({
          pageIndex: 1,
          pageSize: 1000,
        }).then((res) => {
          this.projectList = res.data;
        });
      },
      // 获取列表
      _getData() {
        getAuth({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          status: this.status,
          phone: this.searchType == 1 ? this.searchValue : "",
          url: this.searchType == 2 ? this.searchValue : "",
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
        });
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {

            this.delFunction(id);
          },
        });
      },
      // 删除方法
      delFunction(id) {
        delAuth({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: '如需取消授权请点击编辑封禁其授权即可',
            });
          }
        });
      },
      // 新增按钮
      addClick() {
        this.edit = false
        this.showCreate = true
        this.createData = {
          appid: "",
          user_id: "",
          day: "0",
          url: "",
          phone: "",
          status: 1,
        }
      },
      // 新增方法
      addSave() {

        this.$refs.create.validate((valid) => {
          if (valid) {
            postAuth({
              appid: this.createData.appid,
              user_id: this.createData.user_id,
              authday: this.createData.day,
              url: this.createData.url,
              phone: this.createData.phone,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
              } else {
                this.$Message.error({
                  background: true,
                  content: '暂无权限！请使用授权码方式授权',
                });
              }

            });
          } else {
            this.$Message.warning({
              background: true,
              content: "请先补全带*的必填项",
            });

          }
        });
      },
      // 编辑按钮
      editClick(row) {
        this.edit = true
        this.showCreate = true
        this.createData = {
          ...row
        };
        this.createData.day = 0
      },
      // 获取会员列表
      _getUser() {
        getUserAll().then((res) => {
          this.UserList = res.data;
        });
      },
      // 编辑方法
      editSave() {
        this.$refs.create.validate((valid) => {
          if (valid) {
            putAuth({
              id: this.createData.id,
              phone: this.createData.phone,
              user_id: this.createData.user_id,
              url: this.createData.url,
              appid: this.createData.appid,
              authday: this.createData.day,
              replace: this.createData.replace,
              status: this.createData.status,
            }).then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();

              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
            });
            this.showCreate = false;
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          } else {
            this.creating = false;
            this.$nextTick(() => {
              this.creating = true;
            });
          }
        });
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this._getData();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this._getData();
      },

    },
  };
</script>

<style lang="less" scoped>
  .data-content {
    width: 100%;
    overflow: hidden;
    overflow-x: scroll;

  }

  .list-item {
    min-width: 1000px;
    padding: 12px 0;
    border-bottom: 1px solid #e8eaec;

    .list-item-meta {
      min-width: 25%;
      display: inline-block;

      .list-item-meta-avatar {
        display: inline-block;
      }

      .list-item-meta-content {
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;

        .list-item-meta-title {
          font-weight: 600;
        }
      }
    }

    .list-content {
      min-width: 65%;
      display: inline-block;

      .list-content-item {

        display: inline-block;
        margin-left: 32px;
        color: rgb(128, 134, 149);
        font-size: 14px;
        vertical-align: middle;
      }
    }

    .list-menu-item {
      width: 10%;
      text-align: right;
      display: inline-block;
    }
  }

  .ivu-bg {
    box-shadow: 0 0 17px 0 rgba(130, 122, 122, 0.1);
    margin-bottom: 10px;
    border-radius: 0.35rem;

    .ivu-text-center {
      text-align: center;
    }

    .ivu-mt {
      margin: 16px 0;
    }
  }
  /deep/ .ivu-radio-wrapper-checked {
    background: #2d8cf0;
    color: #fff;
  }
</style>